import { FormLabel } from "@/components/ui/form"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { INPUT_FIELD_CLASSNAME } from "@/constants/classname/classname"
import { SelectOption } from "@/types/inputField"

export const DestinationSelectInputField = ({
  label,
  value,
  selectOptions,
  onChange,
  labelDescription,
  isDisabled,
  additionalClassName,
  hasError,
}: {
  value: string,
  selectOptions: SelectOption[],
  onChange: (value: string) => void,
  label?: string,
  labelDescription?: string,
  isDisabled?: boolean
  additionalClassName?: string
  hasError?: boolean
}) => (
  <div className="flex flex-col w-full">
    {label && (
      <FormLabel className="flex justify-start font-semibold text-primary !text-sm">
        {label}
      </FormLabel>
    )}
    {labelDescription && <p className="text-secondary text-sm font-normal -mt-1 mb-1 text-left">{labelDescription}</p>}
    <Select value={value} onValueChange={onChange} disabled={isDisabled}>
      <SelectTrigger className={
        INPUT_FIELD_CLASSNAME +
        ' w-full bg-background text-primary ' +
        additionalClassName +
        `${!value && hasError ? " !border-destructive !bg-destructive-foreground" : ""}`
      }>
        <SelectValue placeholder="Select">
          {selectOptions.find(a => a.id === value)?.value ?? ''}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className={'w-full bg-background text-primary ' + additionalClassName}>
        {selectOptions.map((opt, i) => (
          <SelectItem
            key={i + opt.id}
            value={opt.id}
            className="flex flex-col items-start justify-start"
          >
            <p>{opt.value}</p>
            {opt?.description ? <span className="text-sm text-secondary">{opt?.description}</span> : null}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
)
